import DefaultAnalyticsConfig from "../../../src/common/analytics/defaultAnalyticsConfig";

let erTag = DefaultAnalyticsConfig.erTag;
let tealiumUtagUrl =
  "https://dev-components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/preprod/utag.js";
let tealiumUtagSyncUrl =
  "https://dev-components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/preprod/utag.sync.js";
let tealiumCpmtUrl =
  "https://dev-components2.gazzettaobjects.it/rcs_cpmt/v1/distro/gazzetta_noWall_ct.js";
let tealiumUtagDomain = "dev-components2.gazzettaobjects.it";
let tealiumUtagPath =
  "https://dev-components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/preprod/";
let tealiumUtagEnv = "preprod";

if (process.env.ENV === "production") {
  erTag = "5b309519f5304f198bc66edbc350c403";
  tealiumUtagUrl =
    "https://components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/prod/utag.js";
  tealiumUtagSyncUrl =
    "https://components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/prod/utag.sync.js";
  tealiumCpmtUrl =
    "https://components2.gazzettaobjects.it/rcs_cpmt/v1/distro/gazzetta_noWall_ct.js";
  tealiumUtagDomain = "components2.gazzettaobjects.it";
  tealiumUtagPath =
    "https://components2.gazzettaobjects.it/rcs_tealium/v1/distro/gazzetta/prod/";
  tealiumUtagEnv = "prod";
}

export default class AnalyticsConfig extends DefaultAnalyticsConfig {
  static erTag = erTag;
  static erUserReferenceType = "subscriptionReference";
  static tealium = {
    utagUrl: tealiumUtagUrl,
    utagSyncUrl: tealiumUtagSyncUrl,
    cpmtUrl: tealiumCpmtUrl,
    utagDomain: tealiumUtagDomain,
    utagPath: tealiumUtagPath,
    utagEnv: tealiumUtagEnv,
  };
}



// WEBPACK FOOTER //
// ./clients/rcs-gds/js/analyticsConfig.js